/** Через new URL, а не конкатенацией: в перехваченном path уже есть query. */
export const buildDraftActionUrl = (path: string, draftAction: 'new' | 'continue'): string => {
  const url = new URL(path, window.location.origin);

  url.searchParams.set('draftAction', draftAction);

  return url.toString();
};
